module.exports = __webpack_public_path__ + "img/applets2.5885a3a5.png";